import React from 'react';
import { PropertyType, getArea } from '@domain-group/fe-allhomes-library';
import { StatisticsContainer, Item, Value, Label, Suffix } from './vital-statistics.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Stats = {
  buildingSize: {
    label: propertyTypeName => "".concat(PropertyType[propertyTypeName].label, " size:"),
    shortLabel: propertyTypeName => "".concat(PropertyType[propertyTypeName].label, ":"),
    suffix: 'approx.'
  },
  blockSize: {
    label: () => 'Block size:',
    shortLabel: () => 'Block:',
    suffix: 'approx.'
  },
  unimprovedValue: {
    label: () => 'UV:',
    shortLabel: () => 'UV:'
  },
  floor: {
    label: () => 'On floor:',
    shortLabel: () => 'On floor:'
  }
};
export var VitalStatistics = _ref => {
  var propertyType = _ref.propertyType,
    blockSize = _ref.blockSize,
    buildingSize = _ref.buildingSize,
    _ref$unimprovedValue = _ref.unimprovedValue,
    unimprovedValue = _ref$unimprovedValue === void 0 ? '' : _ref$unimprovedValue,
    _ref$floor = _ref.floor,
    floor = _ref$floor === void 0 ? '' : _ref$floor,
    _ref$shortLabels = _ref.shortLabels,
    shortLabels = _ref$shortLabels === void 0 ? false : _ref$shortLabels;
  var renderStat = (stat, value) => value && ___EmotionJSX(Item, null, ___EmotionJSX(Label, null, (shortLabels ? stat.shortLabel : stat.label)(propertyType !== null && propertyType !== void 0 ? propertyType : 'PROPERTY'), "\xA0"), ___EmotionJSX(Value, null, value, stat.suffix && ___EmotionJSX(Suffix, null, stat.suffix)));
  var renderSizeStat = (stat, value) => {
    var area = getArea(value);
    return value ? renderStat(stat, "".concat(area.value, " ").concat(shortLabels ? area.unitAbbrev : area.unit, " ")) : '';
  };
  var buildingSizeNum = parseInt("".concat(buildingSize), 10);
  var blockSizeNum = parseInt("".concat(blockSize), 10);
  return buildingSizeNum || blockSizeNum || unimprovedValue || floor ? ___EmotionJSX(StatisticsContainer, null, renderSizeStat(Stats.blockSize, blockSizeNum), renderSizeStat(Stats.buildingSize, buildingSizeNum), renderStat(Stats.unimprovedValue, unimprovedValue), renderStat(Stats.floor, floor)) : null;
};